import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { JwtAuthService } from '../services/auth/jwt-auth.service';
import { Observable, of, tap } from 'rxjs';
import { OrganizationEntityService } from '../../state/entity-services/organization-entity.service';
import { OrganizationService } from '../services/organization.service';
import { map } from 'rxjs/operators';

@Injectable()
export class OrganizationDetailGuard implements CanActivate {

  queryParams: Record<string, any>;

  constructor(
    private jwtAuthService: JwtAuthService,
    private organizationService: OrganizationService,
    private organizationEntityService: OrganizationEntityService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (!this.jwtAuthService.isLoggedIn || !this.jwtAuthService.getUser()?.id) {
      this.redirectToLogin(state.url);
      return of(false);
    }

    const organization = this.organizationService.getOrganization();

    const organizationId = this.findOrganization(route);
    if (!organizationId) {
      return of(false);
    }

    if (organizationId === organization?.id?.toString()) {
      return of(true);
    }

    return this.loadOrganization(organizationId);
  }

  private redirectToLogin(returnUrl: string): void {
    this.router.navigate(['/sessions/login'], { queryParams: { return: returnUrl } });
  }

  private findOrganization(route: ActivatedRouteSnapshot): string | undefined {
    return route?.params['organizationId'] || route?.children && this.findOrganization(route.children[0]);
  }

  private loadOrganization(organizationId: string): Observable<boolean> {
    return this.organizationEntityService.getById(organizationId).pipe(
      tap(organizationEntity => {
        this.organizationService.setOrganization(organizationEntity);
      }),
      map(() => true)
    );

  }
}
